import Select from "@/components/atoms/Select";
import { ITableFilterComponentProps } from "@/interfaces/Table";
import { useGetInstructorFilterOptionsQuery } from "@/services/instructors";
import { FC } from "react";
import { Alert, Button, Card, Form } from "react-bootstrap";

const InstructorFilters: FC<ITableFilterComponentProps> = ({
  filters,
  onFiltersChange,
}) => {
  const { data, isFetching, isError, refetch } =
    useGetInstructorFilterOptionsQuery();
  const areas = data?.areas.map((area) => ({ value: area, label: area })) ?? [];
  const courses = data?.courses ?? [];
  const selectedAreas: string[] =
    filters.areas ?? (filters.area ? [filters.area] : []);
  const selectedCourseIds: string[] =
    filters.courseIds ?? (filters.courseId ? [filters.courseId] : []);

  return (
    <Card className="shadow-none shadow-show-xl scrollbar h-100">
      <Card.Body>
        {isError && (
          <Alert variant="danger">
            Impossible de charger les filtres.
            <Button variant="link" size="sm" onClick={() => refetch()}>
              Réessayer
            </Button>
          </Alert>
        )}
        <Form.Group className="mb-3" controlId="instructor-area">
          <Form.Label>Zones géographiques</Form.Label>
          <Select
            inputId="instructor-area"
            isMulti
            options={areas}
            value={selectedAreas.map((area) => ({ value: area, label: area }))}
            onChange={(options) =>
              onFiltersChange({
                areas: options.length
                  ? options.map(({ value }) => value)
                  : undefined,
                area: undefined,
              })
            }
            isLoading={isFetching}
            isClearable
            placeholder="Toutes les zones"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="instructor-course">
          <Form.Label>Formations</Form.Label>
          <Select
            inputId="instructor-course"
            isMulti
            options={courses}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            value={courses.filter(({ id }) => selectedCourseIds.includes(id))}
            onChange={(options) =>
              onFiltersChange({
                courseIds: options.length
                  ? options.map(({ id }) => id)
                  : undefined,
                courseId: undefined,
              })
            }
            isLoading={isFetching}
            isClearable
            placeholder="Toutes les formations"
          />
        </Form.Group>
        <p className="text-700 fs--1">
          Au moins une formation et une zone parmi celles sélectionnées.
        </p>
        <Button
          variant="primary"
          onClick={() =>
            onFiltersChange({
              area: undefined,
              courseId: undefined,
              areas: undefined,
              courseIds: undefined,
              globalFilter: "",
            })
          }
        >
          Réinitialiser
        </Button>
      </Card.Body>
    </Card>
  );
};

export default InstructorFilters;
